import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminTranscriptReviewService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminTranscriptReviewKeys } from 'app/queries/adminTranscriptReview/adminTranscriptReviewKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminTranscriptReviewKeys.styleFixManifest>>;

export const createFetchStyleFixFixtureManifestQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminTranscriptReviewService.getStyleFixFixtureManifest({ jobId }), signal), {
      dontRedirectOnError: true,
    });
